import { Dtos } from '#models';
import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { of, OperatorFunction, switchMap, throwError } from 'rxjs';

export interface ToastrMessage {
  detail: string;
  summary: string;
}

@Injectable({
  providedIn: 'root',
})
export class ErrorHelperService {
  private _translateService = inject(TranslateService);

  handleError(err: unknown): ToastrMessage {
    if (err instanceof HttpErrorResponse && err.status === 403) {
      return { detail: this._translateService.instant('common.forbidActionErrorMessage'), summary: '' };
    }

    if (err instanceof HttpErrorResponse && err.error) {
      const { ExceptionMessage = '', Title = '' } = err.error;

      if (Title !== '' && ExceptionMessage !== '') {
        return {
          detail: ExceptionMessage,
          summary: Title,
        };
      }
    }

    return {
      detail: this._translateService.instant('common.genericErrorMessage'),
      summary: '',
    };
  }

  // Turns a ResultModel response into an HttpErrorResponse when the API reports failure.
  checkApiResponse<T>(value: T): OperatorFunction<Dtos.ResultModel, T> {
    return switchMap(res => {
      if (!res.Success) {
        return throwError(
          () =>
            new HttpErrorResponse({
              error: {
                ExceptionMessage: res.Message,
                Title: 'Error',
              },
              status: 400,
              statusText: 'Bad Request',
            })
        );
      }

      return of(value);
    });
  }
}
